import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import theme from '../../constants/theme';
import logoImg from '../../assets/images/logo.png';

export default function Navbar({ scrolled }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'py-4 shadow-md' : 'py-6'}`}
      style={{
        backgroundColor: scrolled ? 'rgba(251, 251, 245, 0.95)' : 'transparent',
        backdropFilter: scrolled ? 'blur(10px)' : 'none',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo(0, 0)}>
          <img
            src={logoImg}
            alt="MiraAI.sol Logo"
            className="h-12 md:h-14 w-auto object-contain"
          />
<div className="text-2xl tracking-wider" style={{ textTransform: 'none' }}>
  <span className="font-tech font-bold">Mira</span><span className="font-retropix" style={{ color: theme.primary }}>AI.SOL</span>
</div>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8 text-sm font-bold uppercase tracking-widest">
          <a href="#about" className="hover:text-[#c60664] transition-colors">Story</a>
          <a href="#services" className="hover:text-[#c60664] transition-colors">Services</a>
          <a href="#portfolio" className="hover:text-[#c60664] transition-colors">Work</a>
          <a
            href="#contact"
            className="px-6 py-2 border-2 transition-all duration-300"
            style={{ borderColor: theme.primary, color: theme.primary }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = theme.primary; e.target.style.color = theme.bg; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = theme.primary; }}
          >
            Let's Talk
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)} style={{ color: theme.primary }}>
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMenuOpen && (
        <div
          className="md:hidden absolute top-full left-0 w-full shadow-lg border-t"
          style={{ backgroundColor: theme.bg, borderColor: 'rgba(198, 6, 100, 0.1)' }}
        >
          <div className="flex flex-col p-6 gap-4 text-sm font-bold uppercase tracking-widest text-center">
            <a href="#about" onClick={() => setIsMenuOpen(false)} className="py-2 hover:text-[#c60664]">Story</a>
            <a href="#services" onClick={() => setIsMenuOpen(false)} className="py-2 hover:text-[#c60664]">Services</a>
            <a href="#portfolio" onClick={() => setIsMenuOpen(false)} className="py-2 hover:text-[#c60664]">Work</a>
            <a
              href="#contact"
              onClick={() => setIsMenuOpen(false)}
              className="py-3 mt-2 border-2"
              style={{ borderColor: theme.primary, color: theme.primary }}
            >
              Let's Talk
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
